import React from 'react';

const AcceptedDocIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="8" fill="#00C48C" />
    <path d="M4.66699 8.25L6.91794 10.5L11.4179 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default AcceptedDocIcon;
